import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import cancelIcon from '../../icons/successIcon.png';
import { Button, Box, Typography } from '@material-ui/core';

const useStyles = makeStyles(({ spacing, palette }) => ({
  button: {
    height: 48,
    backgroundColor: palette.primary.main,
    color: 'white',
    fontSize: 16,
    lineHeight: '24px',
    width: 180,
    marginTop: 30,
    margin: '0 auto',
  },
  paper: {
    position: 'absolute',
    width: 531,
    backgroundColor: 'white',
    height: 173,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    justifyContent: 'center',
    padding: '60px 70px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    color: palette.text.primary,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '32px',
    marginBottom: 15,
    fontFamily: 'Inter',
  },
  img: {
    width: 60,
    height: 60,
    marginRight: 30,
  },

  fieldLable: {
    color: palette.primary.main,
    paddingTop: 12,
  },
  text: {
    color: palette.text.primary,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '-0.01em',
    fontFamily: 'Inter',
  },
}));

function getModalStyle() {
  const top = '50%';
  const right = 0;
  return {
    top: `${top}%`,
    right: `${right}%`,
  };
}

interface IProps {
  onClose: () => void;
  reportsIsBeignGeneratedPopupVisible: boolean;
}

const ReportIsBeingGeneratedPopup = ({
  onClose,
  reportsIsBeignGeneratedPopupVisible,
}: IProps) => {
  const classes = useStyles();

  const [modalStyle] = React.useState(getModalStyle);

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={reportsIsBeignGeneratedPopupVisible}
      onClose={onClose}
    >
      <Box style={modalStyle} className={classes.paper}>
        <Box className={classes.header}>
          <Box>
            <img src={cancelIcon} className={classes.img} alt="close" />
          </Box>
          <Box>
            <Typography className={classes.title}>
              Your report is being generated.
            </Typography>
            <Typography className={classes.text}>
              Please wait here for a few minutes for your report to be generated. If you press Ok, you will be notified when the report is available for download.
            </Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          type="submit"
          className={classes.button}
          size="large"
          onClick={onClose}
        >
          Ok
        </Button>
      </Box>
    </Modal>
  );
};

export default ReportIsBeingGeneratedPopup;
